// extracted by mini-css-extract-plugin
export default {"box":"index_box_F9W48","footer":"index_footer_Y-JFQ"};